import Vue from 'vue'
import Router from 'vue-router'
//测试页面
const img = resolve => require(['../components/imgTest'], resolve)
const imgs = resolve => require(['../components/imgsTest'], resolve)
//顶级页面
const login = resolve => require(['../page/login/login'], resolve)
const home = resolve => require(['../page/home'], resolve)
//login的二级页面
const studentLogin = resolve => require(['../page/login/studentLogin'], resolve)
const schoolLogin = resolve => require(['../page/login/schoolLogin'], resolve)
const adminLogin = resolve => require(['../page/login/adminLogin'], resolve)

//home的二级页面
const index = resolve => require(['../page/index/index'], resolve)
//由index进入的二级页面
const schoolIntro = resolve => require(['../page/index/schoolIntro'], resolve)
const classroomShow = resolve => require(['../page/index/classShow/classroomShow'], resolve)
const showDetail = resolve => require(['../page/index/classShow/showDetail'], resolve)
const addClassShow = resolve => require(['../page/index/classShow/addClassShow'], resolve)
const allCourse = resolve => require(['../page/index/course/allCourse'], resolve)
const classCourse = resolve => require(['../page/index/course/classCourse'], resolve)
//home的二级页面
const check = resolve => require(['../page/check/check'], resolve)
const searchCheck = resolve => require(['../page/check/searchCheck'], resolve)

//home的二级页面
const interaction = resolve => require(['../page/interaction/interaction'], resolve)
//由interaction进入的二级页面
const schoolInteraction = resolve => require(['../page/interaction/schoolInteraction'], resolve)
const sIDetail = resolve => require(['../page/interaction/sIDetail'], resolve)
const addInteraction = resolve => require(['../page/interaction/addInteraction'], resolve)
//home的二级页面
const my = resolve => require(['../page/my/my'], resolve)
//由my进入的二级页面
const personalInfo = resolve => require(['../page/my/personalInfo/personalInfo'], resolve)
const changePhone = resolve => require(['../page/my/personalInfo/changePhone'], resolve)
const changeImg = resolve => require(['../page/my/personalInfo/changeImg'], resolve)
const changeIdentity = resolve => require(['../page/my/changeIdentity'], resolve)
const personalStatistics = resolve => require(['../page/my/personalStatistics'], resolve)
const feedback = resolve => require(['../page/my/feedback'], resolve)

// Router.prototype.goBack = function () {
//   this.isBack = true
//   window.history.go(-1)
// }
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/login',
      component: home,
      children: [
        { path: '/index', name: '首页', component: index },
        { path: '/index/schoolIntro', name: '学校简介', component: schoolIntro },
        { path: '/index/classroomShow', name: '课堂风采', component: classroomShow },
        { path: '/index/showDetail', name: '课堂风采详情', component: showDetail },
        { path: '/index/addClassShow', name: '新增课堂风采', component: addClassShow },
        { path: '/index/allCourse', name: '课程表', component: allCourse },
        { path: '/index/classCourse', name: '班级课程表', component: classCourse },

        { path: '/check', name: '考勤', component: check },
        { path: '/check/searchCheck', name: '查询考勤', component: searchCheck },

        { path: '/interaction', name: '互动', component: interaction },
        { path: '/interaction/schoolInteraction', name: '学校活动', component: schoolInteraction },
        { path: '/interaction/sIDetail', name: '学校活动详情', component: sIDetail },
        { path: '/interaction/addInteraction', name: '新增学校活动', component: addInteraction },

        { path: '/my', name: '我的', component: my },
        { path: '/my/personalInfo', name: '个人信息', component: personalInfo },
        { path: '/my/changeImg', name: '更换头像', component: changeImg },
        { path: '/my/changeIdentity', name: '切换身份', component: changeIdentity },
        { path: '/my/personalStatistics', name: '个人统计', component: personalStatistics },
        { path: '/my/feedback', name: '意见反馈', component: feedback },
      ]
    },
    {path: '/login',name: 'login',component: login },
    { path: '/studentLogin', name: '家长版登录', component: studentLogin },
    { path: '/schoolLogin', name: '教师版登录', component: schoolLogin },
    { path: '/adminLogin', name: '管理员版登录', component: adminLogin },

    //一些在四个组件内 但是不想显示tabbar的页面
    { path: '/my/changePhone', name: '更换手机', component: changePhone },

    {
      path: '/img',
      name: 'img',
      component: img,
      children: []
    },
    {
      path: '/imgs',
      name: 'imgs',
      component: imgs,
      children: []
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js